import React from 'react';
import { ThemeProvider } from '@kaena1/mm-ui-components';
import { theme } from '@kaena1/mm-ui-theme-v3';
import '@kaena1/mm-ui-theme-v3/styles.css';
import '@kaena1/mm-ui-components/components.css';
import { CustomerSupport } from './components/CustomerSupport';
import './css/CustomerSupport.module.scss'; 
import { createRoot } from 'react-dom/client';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
        <CustomerSupport />
    </ThemeProvider>
  );
};

const customerSupportRoot = document.getElementById('customer-support-root');

if (customerSupportRoot) {
  const root = createRoot(customerSupportRoot);
  root.render(<App />);
}